import React, { useMemo, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { getBrandLogos } from "../../helpers/brandPortal";
import { acceptTeamInvite } from "../../helpers/team_helper";

const AcceptInvite = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token")?.trim() || "", [params]);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    if (!token) {
      setError(t("inviteAccept.missingToken"));
      return;
    }
    if (password.length < 8) {
      setError(t("inviteAccept.passwordMin"));
      return;
    }
    if (password !== confirmPassword) {
      setError(t("inviteAccept.passwordMismatch"));
      return;
    }
    setBusy(true);
    try {
      await acceptTeamInvite({ token, name: name.trim(), password });
      // O aceite não devolve JWT; o login confirma as credenciais sem expor o convite.
      navigate("/login?invite=accepted", { replace: true });
    } catch (e: any) {
      setError(e?.message || t("inviteAccept.error"));
    } finally {
      setBusy(false);
    }
  };

  document.title = t("inviteAccept.documentTitle");

  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">
        <Container>
          <Row><Col lg={12}><div className="text-center mt-sm-5 mb-4"><Link to="/login"><img src={getBrandLogos().dark} alt={getBrandLogos().alt} height="20" /></Link></div></Col></Row>
          <Row className="justify-content-center"><Col md={8} lg={6} xl={5}>
            <Card className="mt-4 card-bg-fill"><CardBody className="p-4">
              <div className="text-center mt-2"><h5 className="text-primary">{t("inviteAccept.title")}</h5><p className="text-muted">{t("inviteAccept.subtitle")}</p></div>
              {!token && <Alert color="warning">{t("inviteAccept.missingToken")}</Alert>}
              {error && <Alert color="danger">{error}</Alert>}
              <Form className="mt-4" onSubmit={submit}>
                <div className="mb-3"><Label htmlFor="invite-name">{t("inviteAccept.name")}</Label><Input id="invite-name" required autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} /></div>
                <div className="mb-3"><Label htmlFor="invite-password">{t("inviteAccept.password")}</Label><Input id="invite-password" required minLength={8} type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} /><div className="form-text">{t("inviteAccept.passwordHelp")}</div></div>
                <div className="mb-3"><Label htmlFor="invite-confirm">{t("inviteAccept.confirm")}</Label><Input id="invite-confirm" required type="password" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} /></div>
                <Button color="success" className="w-100" disabled={busy || !token}>{busy ? <Spinner size="sm" className="me-2" /> : null}{t("inviteAccept.submit")}</Button>
              </Form>
            </CardBody></Card>
            <div className="text-center mt-4"><Link to="/login">{t("inviteAccept.backLogin")}</Link></div>
          </Col></Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

export default AcceptInvite;
